// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"7740":"css/app.6723","8030":"css/admin-app.6723"}[chunkId] + ".css";
};